// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@sc/XDL/Icons/Close";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        closeButtonProps: {
            size: 24,
            css: css`
                &&&,
                &&&:focus,
                &&&:hover {
                    background: transparent;
                    border: none;
                }
                &,
                ${IconWrapper} {
                    color: ${color("text.main")};
                }
                &:hover {
                    svg {
                        color: ${color("common.ui8")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            ...DrawerPresentationPropsDefault.closeButtonIconProps,
            src: Close,
            size: 14,
        },
        cssOverrides: {
            drawerBody: css`
                background: ${getColor("common.background")};
            `,
            drawerTitle: css`
                background: ${getColor("common.background")};
            `,
        },
        headlineTypographyProps: {
            color: "text.main",
        },
    },
} as xBaseTheme["drawer"];
